import { localStorage } from "@/utils/localStorage";
export const VERSION = "1.0.4";

// house（座位表）缓存的版本号。
// 当座位表的数据结构 / 处理逻辑发生变化（例如座席種類、translate 重叠等修复）时，
// 递增此版本号，用户下次打开应用时会自动清除旧的 house 缓存，避免使用到旧结构的脏数据。
export const HOUSE_STORAGE_VERSION = "1.0.0";

// 编辑 / 排程流程中缓存到 localStorage 的 house 数据 key
export const HOUSE_STORAGE_KEYS = ["theatre", "scheduleObj", "scheduleAddObj"];

const HOUSE_STORAGE_META_KEY = "HOUSE_STORAGE_META";

// 当 house 缓存版本更新时，自动清除已保存的 house localStorage 数据。
// 用对象形式保存版本号，确保 localStorage.get 的 JSON.parse 能正确取回，从而只在版本变化时清除一次。
export const clearHouseData = () => {
  const meta = localStorage.get(HOUSE_STORAGE_META_KEY) || {};

  if (meta.version !== HOUSE_STORAGE_VERSION) {
    HOUSE_STORAGE_KEYS.forEach(key => localStorage.remove(key));
    localStorage.set(HOUSE_STORAGE_META_KEY, { version: HOUSE_STORAGE_VERSION });
  }
};

export const clearData = () => {
  // const userOptions = localStorage.get('userOptions');
  // const movie_filterOptions = localStorage.get('movie_filterOptions');
  const version = localStorage.get("APP_VERSION");

  if (!version || version !== VERSION) {
    localStorage.remove("userOptions");
    localStorage.remove("movie_filterOptions");
    localStorage.set("APP_VERSION", VERSION);
  }

  // house 缓存按自身版本号单独管理，结构变化时自动清除
  clearHouseData();
};
